<template>
  <v-autocomplete
    v-model="selected"
    :items="selectorOptions"
    :loading="loading"
    :label="fieldLabel"
    :rules="rule"
    :multiple="!single"
    :clearable="!single"
    item-value="id"
    item-text="title"
    no-data-text="Ничего не найдено"
    prepend-inner-icon="mdi mdi-reload mdi-18px"
    @click:prepend-inner="refresh"
  >
    <template #selection="{ item, index }">
      <span v-if="single">{{ item.title }}</span>
      <v-chip v-else-if="index === 0" small style="max-width: 130px">
        <span class="sliced-name">{{ item.title }}</span>
      </v-chip>
      <span v-else-if="index === 1" class="grey--text caption">(+{{ selected.length - 1 }})</span>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ManagerSelector',

  props: {
    value: {
      required: true,
    },
    single: Boolean,
    noRules: Boolean,
    fieldLabel: {
      type: String,
      default: 'Менеджер',
    },
  },

  data() {
    return {
      selectorOptions: [],
      loading: false,
      rule: [
        v => {
          if (this.noRules) return true
          if (this.single) return !!v || 'Данное поле обязательно'
          return !!(v && v.length) || 'Данное поле обязательно'
        },
      ],
    }
  },

  computed: {
    selected: {
      get() {
        return this.value
      },
      set(selected) {
        this.$emit('input', selected)
      },
    },
  },

  methods: {
    ...mapActions({
      loadUsers: 'graphql/loadUsers',
    }),

    async refresh() {
      this.selected = this.single ? null : []
      await this.sendRequest()
    },

    async sendRequest() {
      this.loading = true

      const graphQuery = {
        query: `{
          users (roles: ["manager"]) {
            data {
              id
              title
            }
          }
        }`,
      }

      try {
        const resp = await this.loadUsers(graphQuery)
        this.selectorOptions = (resp.data || [])
          .slice()
          .sort((a, b) => String(a.title).localeCompare(String(b.title), 'ru'))
      } finally {
        this.loading = false
      }
    },
  },

  async mounted() {
    await this.sendRequest()
  },
}
</script>

<style scoped>
.sliced-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
